module.exports = __webpack_public_path__ + "img/heroBanner.ed35561a.png";